import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { auth } from '../services/auth'
import { LandlordProvider } from './LandlordContext'
import { Home } from './screens/Home'
import { LandlordAuth } from './screens/LandlordAuth'
import { LandlordOnboarding } from './screens/LandlordOnboarding'
import LandlordLeaseAnalysis from './LandlordLeaseAnalysis'
import { LandlordPricing } from './screens/LandlordPricing'
import { AttorneyHandoff } from './screens/AttorneyHandoff'

function RequireAuth({ children }) {
  return auth.isAuthenticated() ? children : <Navigate to="/login" replace />
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      suspense: true,
    },
  },
})

export default function LandlordApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LandlordProvider>
          <Routes>
            <Route path="/login" element={<LandlordAuth />} />
            <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
            <Route path="/onboarding" element={<RequireAuth><LandlordOnboarding /></RequireAuth>} />
            <Route path="/analysis" element={<RequireAuth><LandlordLeaseAnalysis /></RequireAuth>} />
            <Route path="/pricing" element={<RequireAuth><LandlordPricing /></RequireAuth>} />
            <Route path="/attorneys" element={<RequireAuth><AttorneyHandoff /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </LandlordProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
